var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%","height":"100%"}},[(_vm.title)?_c('fx-titre',{attrs:{"titre":_vm.title}}):_vm._e(),_c('div',{staticStyle:{"width":"100%","height":"100%"},attrs:{"id":_vm.id}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }